module.exports = __webpack_public_path__ + "img/quality.38186dc9.png";